import React, { useState } from 'react';
import { Form, Input } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import firebase, { auth, firestore } from '../firebase';

function Password() {
	const details = useSelector((state) => state.auth.details);
	const [success, setSuccess] = useState(null);
	const [error, setError] = useState(null);

	return (
		<Formik
			initialValues={{
				password: '',
				confirmPassword: '',
			}}
			validationSchema={Yup.object().shape({
				password: Yup.string().required('La contraseña es requerido.'),
				confirmPassword: Yup.string()
					.oneOf([Yup.ref('password')], 'Las contraseñas no son iguales')
					.required('Confirmar la contraseña es requerido.'),
			})}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				//console.log(values);
				const { currentUser } = auth;
				const credential = firebase.auth.EmailAuthProvider.credential(
					details.email,
					details.password
				);
				currentUser.reauthenticateWithCredential(credential).then(() => {
					currentUser
						.updatePassword(values.password)
						.then(() => {
							firestore
								.collection('users')
								.doc(details.doc)
								.update({ password: values.password })
								.then(() => {
									setSubmitting(false);
									resetForm();
									setSuccess('¡La contraseña ha sido modificada exitosamente!');
									setTimeout(() => {
										setSuccess(null);
									}, 5000);
								})
								.catch((err) => {
									setSubmitting(false);
									setError(err.message);
									setTimeout(() => {
										setError(null);
									}, 5000);
								});
						})
						.catch((err) => {
							setError(err.message);
							setSubmitting(false);
							setTimeout(() => {
								setError(null);
							}, 5000);
						});
				});
			}}
			render={(props) => {
				const {
					values,
					touched,
					errors,
					handleChange,
					handleBlur,
					handleSubmit,
					isValid,
					isSubmitting,
				} = props;

				return (
					<Form
						size="tiny"
						className="event-form"
						onSubmit={handleSubmit}
						noValidate
					>
						<Form.Group widths="equal">
							<Form.Field
								label="Nueva Contraseña (Mas de 6 caracteres)"
								name="password"
								type="password"
								placeholder="Contraseña"
								control={Input}
								value={values.password}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.password && touched.password && errors.password}
							/>
							<Form.Field
								label="Confirmar Nueva Contraseña  (Mas de 6 caracteres)"
								name="confirmPassword"
								type="password"
								placeholder="Confirmar Contraseña"
								control={Input}
								value={values.confirmPassword}
								onChange={handleChange}
								onBlur={handleBlur}
								error={
									errors.confirmPassword &&
									touched.confirmPassword &&
									errors.confirmPassword
								}
							/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Button
								size="mini"
								loading={isSubmitting}
								disabled={Boolean(!isValid || isSubmitting)}
								type="submit"
								content="Modificar"
							/>
						</Form.Group>
						{error && <p>{error}</p>}
						{success && <p>{success}</p>}
					</Form>
				);
			}}
		/>
	);
}

export default Password;
